import type { SVGProps } from 'react';
const SvgRifle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
    <path d="M10.174 24 7.5 26.788l4.826 4.712L15 28.745zM31.467 7.531c-.46-.446-8.193 4.012-11.877 7.195L12 22.384 16.843 27l7.479-7.53c3.144-3.725 7.605-11.493 7.145-11.939" />
  </svg>
);
export default SvgRifle;
